module.exports = __webpack_public_path__ + "static/media/ms.cf383479.svg";